import { render, staticRenderFns } from "./DetalhesFornecedor.vue?vue&type=template&id=b40694c4&scoped=true"
import script from "./DetalhesFornecedor.vue?vue&type=script&lang=js"
export * from "./DetalhesFornecedor.vue?vue&type=script&lang=js"
import style0 from "./DetalhesFornecedor.vue?vue&type=style&index=0&id=b40694c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40694c4",
  null
  
)

export default component.exports